module.exports = __webpack_public_path__ + "static/media/top-confetti.3563acc2.svg";